import {combineReducers} from '@reduxjs/toolkit';

import {notificationsListStateSlice} from './notification-list/slices/notification-search-criteria.slice';
import {userNotificationsSlice} from './user-notifications/slices/user-notifications.slice';

export const internalNotificationsReducer = combineReducers({
    notificationsList: notificationsListStateSlice.reducer,
    userNotifications: userNotificationsSlice.reducer,
});
